import { IFeature } from '../services';
import { ICarDetail } from '../redux/carDetails/carDetails.duck.interface';

interface ITrimCompare {
    vehicle: ICarDetail;
    features: { engines: IFeature[]; interiorColors: IFeature[] };
}

export const getUniqueEngines = (trims: ITrimCompare[]): IFeature[] => {
    const uniqueEngines = [] as IFeature[];

    trims?.map((trim: ITrimCompare) => {
        trim?.features?.engines.map((motorization: IFeature) => {
            if (
                !uniqueEngines
                    .map((uniqueEngine) => uniqueEngine.engineGearboxFuelSlug)
                    .includes(motorization.engineGearboxFuelSlug)
            ) {
                uniqueEngines.push(motorization);
            }
        });
    });

    return uniqueEngines;
};

export const isEngineAvailableInConfiguration = (trim: ITrimCompare, motorization: IFeature) =>
    trim.features.engines
        .map(({ engineGearboxFuelSlug }) => engineGearboxFuelSlug)
        .includes(motorization.engineGearboxFuelSlug);

export const getUniqueInteriors = (trims: ITrimCompare[]): IFeature[] => {
    const uniqueInteriorColors = [] as IFeature[];

    trims?.map((trim: ITrimCompare) => {
        trim?.features?.interiorColors.map((interior: IFeature) => {
            if (!uniqueInteriorColors.map((uniqueInterior) => uniqueInterior.id).includes(interior.id)) {
                uniqueInteriorColors.push(interior);
            }
        });
    });

    return uniqueInteriorColors;
};

export const isInteriorAvailableInConfiguration = (trim: ITrimCompare, interiorColor: IFeature) =>
    trim.features.interiorColors.map(({ id }) => id).includes(interiorColor.id);
